import ContactCard from './contactCard';
let contacts = require('../seeders/seedContacts.json');

// function getCardInfo(){
//     const PORT=3000
//     const MONGO_URI="mongodb://localhost:27017/meetings"
//  }
function handleNewContact(){
   // window.location.href= '/create-Meeting'
}



 function Contacts(props) {

   const username = props.user   
   window.localStorage.setItem('cur_user',JSON.stringify(username))
   


   function generateContacts(){
       let contact_map = contacts.map((contact,index) => {
          return (<ContactCard 
                   
                    key={index} 
                    contact={contact} 
                    view={props.view}  
                    setView={props.setView}/>)
       })
       return contact_map   
    }
      function showContactInfo(){
          console.log("ShowContactInfo: ")
      }
    
    return (
        <div className="contacts-container">  
            {/* <h1 className="view-header blink-slower">{props.view}</h1>
            <div className='hub-content-wrap'>
                <div className='hub-button-wrap'>

                    <button
                        id="leave-btn"
                        className="hub-button"
                        onClick={() => showContactInfo()}
                        >
                        test contact
                    </button>
                </div>
            </div> */}
        {/* <div className="meetings-header-wrap" id="meetings-header-wrap" > */}
            <div className="meetings-header" id="meetings-header" >
                  <div className='blink' id="add-contact-link" onClick={handleNewContact}><span className='add-new-meeting-btn'>&nbsp;+&nbsp;</span> &nbsp;new contact</div>
               <span className='blink-slowerer' id="user-tag">greetings:<span className='user-text'> {username}</span></span>
                  <h1 className="view-header blink-slower">{props.view}</h1>
                  
            {/* </div> */}
         </div>
            <div id='meeting-content-wrap'>
               <div className='meeting-content' id="meeting-content">
                  {generateContacts()}
               </div>
            </div>
        </div>
  );
}
export default Contacts; 